/**
 * ConfirmDialog — the branded replacement for window.confirm.
 *
 * Browser-native confirm() boxes are unbranded, unstyleable, and block the
 * JS thread; all destructive-action prompts go through this instead.
 * Defaults follow the house pattern for deletes: red confirm button, grey
 * Cancel, message in plain prose.
 */
import React, { useRef } from 'react';
import {
  AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader,
  AlertDialogBody, AlertDialogFooter, Button, Text,
} from '@chakra-ui/react';

export default function ConfirmDialog({
  isOpen, onClose, onConfirm, title, message,
  confirmLabel = 'DELETE', confirmColorScheme = 'red',
  cancelLabel = 'Cancel', isLoading = false,
}) {
  const cancelRef = useRef();
  return (
    <AlertDialog isOpen={isOpen} onClose={onClose} leastDestructiveRef={cancelRef} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent mx={4}>
          {title && <AlertDialogHeader fontSize="md" pb={1}>{title}</AlertDialogHeader>}
          <AlertDialogBody>
            <Text fontSize="13px" whiteSpace="pre-wrap">{message}</Text>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} size="sm" colorScheme="gray" variant="solid" onClick={onClose}>
              {cancelLabel}
            </Button>
            <Button size="sm" colorScheme={confirmColorScheme} ml={3} onClick={onConfirm} isLoading={isLoading}>
              {confirmLabel}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
